import { CommitteeQueue } from '@/features/committee/ui/CommitteeQueue';

export function CommitteePage() {
  return <CommitteeQueue />;
}
